var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurringDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bulk_card-coin",
    "data-name": "vuesax/bulk/card-coin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.426,
    height: 30.59,
    viewBox: "0 0 30.426 30.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-coin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H30.426V30.59H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M10.841,2.4v.665H0V2.4C0,.48.477,0,2.407,0H8.435C10.364,0,10.841.48,10.841,2.4Z",
    transform: "translate(4.395 16.93)",
    fill: "#191919",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0V3.8C0,5.722.477,6.2,2.407,6.2H8.435c1.93,0,2.407-.48,2.407-2.4V0Z",
    transform: "translate(4.395 19.993)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.582 3.578)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_Stroke_",
    "data-name": "Vector (Stroke)",
    d: "M8.4,0a.815.815,0,0,1,.813.817,8.419,8.419,0,0,1-8.4,8.447A.812.812,0,0,1,.106,8.85a.821.821,0,0,1,.01-.823L1.254,6.119a.811.811,0,0,1,1.116-.28.82.82,0,0,1,.279,1.122l-.294.493A6.8,6.8,0,0,0,7.589.817.815.815,0,0,1,8.4,0Z",
    transform: "translate(14.094 14.17)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_Stroke_2",
    "data-name": "Vector (Stroke)",
    d: "M6.861,1.812A6.8,6.8,0,0,0,1.626,8.447.813.813,0,1,1,0,8.447,8.419,8.419,0,0,1,8.4,0,.812.812,0,0,1,9.11.415a.821.821,0,0,1-.01.823L7.961,3.146a.811.811,0,0,1-1.116.28A.82.82,0,0,1,6.566,2.3Z",
    transform: "translate(0)",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M9.757,0H0A4.9,4.9,0,0,0,4.879,4.9,4.892,4.892,0,0,0,9.757,0Z",
    transform: "translate(17.404 9.301)",
    fill: "#191919",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M9.757,4.9A4.879,4.879,0,1,0,0,4.9Z",
    transform: "translate(17.404 4.396)",
    fill: "#191919"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringDark);
export default __webpack_public_path__ + "static/media/recurring-dark.c7b2d93322cf30cd218a60867832d97f.svg";
export { ForwardRef as ReactComponent };